// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__VLjLq","header":"MessagesList_header__2ehXO","chat":"MessagesList_chat__36pGO"};